<template>
    <div
        class="c-picture-card"
        :class="mainClass"
        :style="wrapStyle"
        @mouseover="coverVisible = true"
        @mouseleave="coverVisible = false"
        @click="handleClick"
    >
        <!-- 图集 -->
        <div v-if="cardType == 'atlas'" class="c-picture-atlas__bg-1">
            <div class="c-picture-atlas__bg-2">
                <div class="c-picture-atlas__bg-3">
                    <el-image
                        style="width: 100%; height: 100%"
                        :src="url"
                        :fit="fit"
                        :error="loadError"
                        :load="loadSuccess"
                    >
                        <div slot="error" class="el-image__error">
                            <div class="bg-blur"></div>
                            <span style="z-index: 2">加载失败</span>
                        </div>
                    </el-image>
                    <slot></slot>
                    <transition name="slide">
                        <div class="c-picture-card__bottom" v-if="bottomShow">
                            <div class="c-picture-card__bottom-content">
                                <slot name="bottom"></slot>
                            </div>
                        </div>
                    </transition>
                    <transition name="slide-top">
                        <div class="c-picture-card__top" v-if="topShow">
                            <slot name="top"></slot>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <!-- 图片 -->
        <div v-if="cardType == 'picture'" class="c-picture-pic">
            <el-image
                style="width: 100%; height: 100%"
                :src="url"
                :fit="fit"
                :error="loadError"
                :load="loadSuccess"
                :class="{ 'c-el-image__border': border }"
            >
                <div slot="error" class="el-image__error">
                    <div class="bg-blur"></div>
                    <span style="z-index: 2">加载失败</span>
                </div>
            </el-image>
            <slot></slot>

            <transition name="slide-top">
                <div class="c-picture-card__top" v-if="topShow">
                    <slot name="top"></slot>
                </div>
            </transition>
            <transition name="slide">
                <div class="c-picture-card__bottom" v-if="bottomShow">
                    <div class="c-picture-card__bottom-content">
                        <slot name="bottom"></slot>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            // 图片地址
            type: String,
            default: '',
        },
        width: {
            // 整个卡片的宽度
            type: [Number, String],
            default: '398px',
        },
        height: {
            // 卡片高度
            type: [Number, String],
            default: '284px',
        },
        fit: {
            // 确定图片如何适应容器框，同原生 object-fit
            type: String,
            validator(val) {
                return ['fill', 'contain', 'cover', ' none', 'scale-down', ''].indexOf(val) !== -1;
            },
            default: '',
        },
        showBottom: {
            // 是否显示图片底部cover层
            type: Boolean,
            default: true,
        },
        bottomShowType: {
            // bottom 显示方式,当showBottom为true时有效，hover:鼠标hover时显示,always:一直显示
            type: String,
            validator(val) {
                return ['hover', 'always'].indexOf(val) !== -1;
            },
            default() {
                return 'hover';
            },
        },
        showTop: {
            // 是否显示图片顶部cover层
            type: Boolean,
            default: true,
        },
        topShowType: {
            // top 显示方式,当showTop为true时有效，hover:鼠标hover时显示,always:一直显示
            type: String,
            validator(val) {
                return ['hover', 'always'].indexOf(val) !== -1;
            },
            default() {
                return 'hover';
            },
        },
        cardType: {
            // 卡片类型
            type: String, // atlas :图集,picture：图片
            default: 'atlas',
        },
        border: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            imageError: false, // 是否加载失败
            coverVisible: false,
        };
    },
    computed: {
        mainClass() {
            let str = '';
            let cardType = this.cardType;
            str = `c-picture-${cardType}`;
            return str;
        },
        wrapStyle() {
            let sty = {};
            let w = this.width;
            let h = this.height;

            sty.width = w;
            sty.height = h;
            return sty;
        },
        bottomShow() {
            // 显示底部cover层
            let show = false;
            let showBottom = this.showBottom;
            if (this.bottomShowType === 'always') {
                show = showBottom;
            } else {
                let coverVisible = this.coverVisible;
                show = showBottom && coverVisible;
            }

            return show;
        },

        topShow() {
            let show = false;
            let showTop = this.showTop;
            if (this.topShowType === 'always') {
                show = showTop;
            } else {
                let coverVisible = this.coverVisible;
                show = showTop && coverVisible;
            }

            return show;
        },
    },
    methods: {
        loadError(e) {
            this.imageError = true;
            this.$emit('error', e);
        },
        loadSuccess(e) {
            this.imageError = false;
            this.$emit('load', e);
        },
        handleClick() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss" scoped>
.c-picture-card {
    position: relative;
    display: inline-block;
    margin: 0 8px 8px 0;
    cursor: pointer;
    ::v-deep .el-image {
        .el-image__error {
            background: #01303f;
        }
        .bg-blur {
            background: #005c84;
            height: 60%;
            width: 60%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            filter: blur(45px);
        }
    }
    .c-el-image__border {
        box-shadow: inset -5px 0px 4px 0px rgba(5, 34, 81, 0.68), inset 5px 0px 4px 0px rgba(5, 34, 81, 0.68),
            inset 0px 5px 6px 0px rgba(48, 106, 186, 0.64);
        border-radius: 0px 0px 0px 0px;
        border: 2px solid;
        transition: all 0.3s;
        border-image: radial-gradient(
                circle,
                rgba(41, 255, 229, 1),
                rgba(163, 253, 237, 1),
                rgba(25, 235, 248, 1),
                rgba(25, 235, 248, 0)
            )
            2 2;
    }
    &__bottom {
        position: absolute;
        bottom: 10px;
        left: 2px;
        width: calc(100% - 12px);
        background: rgba(7, 17, 80, 0.8);
        // transform: translateY(0%);
        &-content {
            padding: 8px;
        }
    }
    &__top {
        position: absolute;
        top: 0px;
        right: 10px;
        width: 40%;
        border-radius: 3px;
        background: rgba(7, 17, 80, 0.8);
    }
    .slide-enter-active {
        animation: slide-in 0.4s;
    }
    .slide-leave-active {
        animation: slide-in 0.4s reverse;
    }
    @keyframes slide-in {
        0% {
            transform: translateY(100%);
        }
        100% {
            transform: translateY(0%);
        }
    }
    .slide-top-enter-active {
        animation: slide-top-in 0.4s;
    }
    .slide-top-leave-active {
        animation: slide-top-in 0.4s reverse;
    }
    @keyframes slide-top-in {
        0% {
            transform: translateY(-100%);
        }
        100% {
            transform: translateY(0%);
        }
    }
}
.c-picture-atlas {
    &__bg-1 {
        height: calc(100% - 9px);
        width: calc(100% - 9px);
        background-color: #2a3686;
        padding-right: 9px;
        padding-bottom: 9px;
        border-radius: 3px;
    }
    &__bg-2 {
        background-color: #3f4da6;
        border-radius: 3px;
        height: calc(100% - 9px);
        width: calc(100% - 9px);
        padding-right: 9px;
        padding-bottom: 9px;
    }
    &__bg-3 {
        position: relative;
        height: calc(100% - 15px);
        width: calc(100% - 12px);
        overflow: hidden;
        background-color: #5867c2;
        border-radius: 3px;
        padding-right: 12px;
        padding-bottom: 15px;
    }
}
.c-picture-picture {
    cursor: default;
    .c-picture-card__bottom {
        bottom: 16px;
        width: 100%;
    }
}
.c-picture-pic {
    height: 100%;
    width: 100%;
    .c-picture-card__bottom {
        bottom: 0px;
    }
}
</style>
